module.exports = __webpack_public_path__ + "img/check_pulse.2ebaa348.png";